/* ═══════════════ GUY COLORS ═══════════════
   UNICA fonte dei colori-fallback usati quando il metafield swatch_hex non è
   impostato sulla variante. Prima queste mappe erano duplicate (e divergenti)
   in carousel.js e product-page.js: ora si modificano SOLO qui.

   Due superfici separate di proposito: i pallini del carosello home e gli
   swatch della pagina prodotto storicamente usano tonalità diverse per alcuni
   colori (es. incense) — unificarle cambierebbe l'aspetto del sito. Se un
   giorno vuoi allinearle, fallo qui ed è fatta ovunque.

   Caricato PRIMA di carousel.js (home) e di product-page.js (prodotto). */
(function () {
  'use strict';

  // Pallini del carosello home (ex COLOR_NAME_MAP di carousel.js)
  const carousel = {
    // Tinte reali dei capi, date da Domenico (settembre 2026). Stessi valori
    // sulle due superfici: prima divergevano e lo stesso capo aveva un
    // pallino diverso fra home e scheda prodotto.
    'celadon':'#cccfbe','incense':'#c6aa8b','boulder':'#f2d6b1',
    'desert sage':'#aeb8a8','desertsage':'#aeb8a8','sage':'#aeb8a8',
    'black':'#1a1a1a','nero':'#1a1a1a','white':'#f5f5f5','bianco':'#f5f5f5',
    'grey':'#888888','gray':'#888888','grigio':'#888888',
    'beige':'#D4B896','cream':'#F0E4D0','panna':'#F0E4D0',
    'red':'#c0392b','rosso':'#c0392b','blue':'#2c4d7a','blu':'#2c4d7a',
    'navy':'#1f2d4a','green':'#3d6b3d','verde':'#3d6b3d',
    'olive':'#6b6b3d','oliva':'#6b6b3d','brown':'#6b4a2b','marrone':'#6b4a2b',
    'tan':'#C19A6B','khaki':'#A89968','sand':'#D9C28C','sabbia':'#D9C28C',
    'mustard':'#C9A227','senape':'#C9A227','pink':'#E8B4C2','rosa':'#E8B4C2',
    'yellow':'#E8D27A','giallo':'#E8D27A','orange':'#E68A4A','arancione':'#E68A4A',
    'purple':'#7A4A8A','viola':'#7A4A8A',
  };

  // Swatch della pagina prodotto (ex colorMap di product-page.js)
  const product = {
    incense:'#c6aa8b',celadon:'#cccfbe','desert sage':'#aeb8a8',boulder:'#f2d6b1',
    black:'#1a1a1a',nero:'#1a1a1a',white:'#f5f5f5',bianco:'#f5f5f5',
    navy:'#1a2744','blu navy':'#1a2744',blue:'#2563eb',blu:'#2563eb',
    'light blue':'#7dd3fc',azzurro:'#7dd3fc',grey:'#6b7280',gray:'#6b7280',
    grigio:'#6b7280',beige:'#d4c5a9',cream:'#fffdd0',crema:'#fffdd0',
    brown:'#8b5a2b',marrone:'#8b5a2b',olive:'#808000',oliva:'#808000',
    burgundy:'#722f37',bordeaux:'#722f37',red:'#dc2626',rosso:'#dc2626',
    pink:'#ec4899',rosa:'#ec4899',green:'#16a34a',verde:'#16a34a',
    orange:'#ea580c',arancione:'#ea580c',yellow:'#eab308',giallo:'#eab308',
    purple:'#9333ea',viola:'#9333ea'
  };

  /** Nome colore → hex per la superficie data; #cccccc se sconosciuto. */
  // lookup: il colore se la mappa lo conosce, altrimenti null. Serve a
  // distinguere "non lo conosco" da "ecco un grigio di ripiego" — senza questo
  // chi chiama non puo' sapere se il #cccccc e' una risposta o una resa.
  function lookup(name, surface) {
    const map = surface === 'product' ? product : carousel;
    const key = (name || '').toLowerCase().trim();
    return map[key] || map[key.replace(/\s+/g, '')] || null;
  }
  function resolve(name, surface) {
    return lookup(name, surface) || '#cccccc';
  }

  window.GuyColors = { carousel, product, resolve, lookup };
})();
